<ng-container *transloco="let t">
    <div class="offcanvas-content d-flex flex-column h-100">
        <div class="offcanvas-header">
            <h4 class="offcanvas-title">{{ t('timing.cache.view.title') }}</h4>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" (click)="dismiss()"></button>

        </div>
        <app-loader [isLoading]="isSaving"></app-loader>
        <div class="offcanvas-body flex-grow-1 overflow-auto">
            <div class="p-4">
                @for (item of measurementTimeItemHolders; track item; let idx = $index) {
                @if(!displayErrorsMap.get(idx)) {
                <div class="item mb-1" (click)="showError(idx)">
                    <div>{{ item.startNumber }}</div>
                    <div class="d-flex">{{ item.time | localizedDate: 'dd.MM.yyyy HH:mm:ss' }}
                        @if (item.saveResult && (item.saveResult !== CompetitorSaveControlPointResultStatus.OK)) {
                        <i class="bi bi-info-circle info-icon ps-2 error"></i>
                        }
                    </div>
                </div>
                }
                @if(displayErrorsMap.get(idx)) {
                <div class="item error-holder mb-1" (click)="showError(idx)">
                     <span>
                        {{ t('measurements.competitor.control.point.save.error.' + item.saveResult)}}
                    </span>
                </div>
                }
                }
            </div>
        </div>

        <div class="offcanvas-footer">
            <div class="d-flex justify-content-between">
                <div class="col-6 px-2">
                    <app-rounded-button
                            [label]="t('app.common.delete')"
                            [fullWidth]="true"
                            [btnClass]="'rounded-button--black-outline'"
                            [isDisabled]="isSaving"
                            (onClick)="onDelete()"
                    ></app-rounded-button>
                </div>
                <div class="col-6 px-2">
                    <app-rounded-button [isDisabled]="isSaving"
                            [label]="t('app.common.save')"
                            (onClick)="onSave()"
                            [fullWidth]="true"
                            [btnClass]="'rounded-button--solid'"
                    ></app-rounded-button>
                </div>
            </div>
        </div>
    </div>
</ng-container>
